import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

// @ts-ignore
import styles from './ElectronicPrescriptionCreateFail.module.scss';

interface Props {
  onConfirm: (reason: string) => void;
  onDecline: () => void;
  errorMessage: string;
}

interface ElectronicPrescriptionCreateFailFormValues {
  reason: string
}

const validationSchema = yup.object({
  reason: yup.string().required('nczi.electronicPrescription.forceReason')
});

const ElectronicPrescriptionCreateFail: React.FC<Props> = props => {
  const { onConfirm, onDecline, errorMessage } = props;

  const formMethods = useForm<ElectronicPrescriptionCreateFailFormValues>({
    defaultValues: {},
    resolver: yupResolver(validationSchema),
  });

  const handleSubmit = (values: ElectronicPrescriptionCreateFailFormValues) => {
    onConfirm(values.reason);
  }


  return (
    <>
      <Text tx={'nczi.electronicPrescription.createFailed.info'} /><br />
      {errorMessage.split('\n').map((line, index) => <Text key={index} tx={line} className={styles.description} />)}
      <div className={styles.controls}>
        <Button title={'nczi.electronicPrescription.createFailed.controls.change'} theme={Theme.GREEN} onClick={onDecline} className={styles.button}/>
      </div>
      <br />
      <FormWrapper formMethods={formMethods}>
        <InputField
          label='nczi.electronicPrescription.forceReason'
          name='reason'
          isRequired
        />
        <div className='mt-4'>
          <SubmitButton
            title={'nczi.electronicPrescription.createFailed.controls.force'}
            onSubmit={handleSubmit}
            className={'btn btn-red-global remastered'}
          />
        </div>
      </FormWrapper>
    </>
  );
};

export default ElectronicPrescriptionCreateFail;
